import React from 'react';
//import styles from './Consulting.css';

function Consulting() {
  return (
<div className="mainContent">
<h1>Script Consulting</h1>
<p>Please email <a href="mailto:claire@clairehutchinson.net">claire@clairehutchinson.net</a> for details on submitting your script and payment.</p>
        <h2>Script Consulting Fees</h2>
        <ol>
            <li>Script Coverage &#8212; $249: 2-3 pages of notes on the main aspects of the script including theme, character, story, dialogue, formatting/grammar, etc. This is used mainly as a tool to determine if the writing is headed in the right direction.</li>
    
        <li>Standard Script Consultation &#8212; $600: 5-8 pages of detailed notes on all aspects of the script, plus suggestions for a rewrite and advice as to next steps. Polish notes after the rewrite: $300.</li>
            
            <li>Standard Script Consultation plus In-depth Notes &#8212; $1200: 10-12 pages of detailed notes on all aspects of the script, plus suggestions for a rewrite and advice as to next steps. Written notes on the script itself. Polish notes after the rewrite: $600.</li>
            
    <li>Total Script Analysis &#8212; $1800: A 20-30 page line by line analysis with an hour phone call to follow up. Polish notes after the rewrite: $900.</li>
            
    </ol>
    <h2>Treatments</h2>
    <p>Negotiable</p>
    <h2>Short films</h2>
    <p>Negotiable</p>
    <h2>Producer's Consultation</h2>
    <p>$5500 &#8211; I will take you from outline to first draft to final draft. Includes consulting on your outline, initial draft and four additional drafts.</p>
    
    <h2>Enhanced Producer's Consultation</h2>
    <p>$7500 &#8211; includes all of the above plus availability during all stages of production, and consultation on two cuts of the film.</p>
    
    <h2>Screenwriting</h2>
    <p>I usually charge WGA wage rates to write an original script, but I'm willing to negotiate the rate for lower budgeted films.</p>
            <blockquote>
                <p>Claire,<br /><br />
    
    Thank you for such excellent analysis and suggestions. I see what you mean, and I guess I intuitively realized some of those weaknesses. When I receive the marked up script, I'll get back on it. Meanwhile, I'll be thinking about scene solutions to amp up the conflict and vary the settings. (In a way, I was trying to limit settings to meet a lower budget, but if that kills the script, then what's the point?) I do agree with your recommendations. I'm working on a non-fiction book right now, but will soon finish. So while it sits before revision, I'll dig in to the script. Good point about Derek so quickly getting a job. Also about the 40s and 50s racism. I wanted to avoid that, but needed something to unite the neighborhood and pastor against them. I like your idea of the pastor being upset about their lack of responsibility in protecting the residents. </p>
   <p>I'll email you again if I have further questions. But I believe your help is invaluable.</p>
   
    <p>Blessings,<br />
    Victoria</p>
             <p> &#8211; <em>Victoria Dorshorn, writer of "Faith House"</em></p>
            </blockquote>
            <blockquote>
            <p>Claire Hutchinson took my novel of over 250 pages (70,000 words) and did a magnificent professional edit to my draft. A test market was just completed to over 100 teachers, principals, and school administrators. They were amazed as to the clarity and flow of the story-line. I attribute much of that to the expertise that Claire providing from her editing. I look forward to having her edit again for me in the future and highly recommend her services if you are considering a professional edit of your material.</p>
    
  <p>&#8211; <em>RW Nelsona<br />
                SilverWind Entertainment</em></p>
            </blockquote>
</div>

  )
  }

export default Consulting;
